/** Column and value-type identifiers shared by the settings list modules. */
export const VALUE_TYPE_OPTION = "option";
export const VALUE_TYPE_TEXT = "text";
export const ACTIONS_COLUMN_KEY = "actions";
export const ACTIONS_COLUMN_KEY_PREFIX = "actions-";
export const SETTINGS_COLUMN_KEY = "settings";
export const EDIT_ACTION_KEY = "edit";
export const ALIGN_RIGHT = "right";
export const ALIGN_END = "end";
export const ALIGN_CENTER = "center";
export const GENERIC_ERROR_MESSAGES: readonly string[] = ["Fehler", "Error"];
export const ANONYMOUS_ACCOUNT_ID = "anon";
